import { useQuery } from '@tanstack/react-query'
import { api } from '../../../shared/api'

// Mirror of fm.Firma — FileMaker MCCloud::Firma layout.
export interface Firma {
  id: number
  firma: string | null          // short name (e.g. "GmbH")
  vollname: string | null       // full legal name
  adresse: string | null
  plz: string | null
  stadt: string | null
  bank: string | null
  bic: string | null
  iban: string | null
  vertretenDurch: string | null
  stempel: string | null        // URL to stamp image
  syncedAt: string
  /** Switched on in /admin/firma-policy. Stored on hr.FirmaPolicy, not on the
   *  FileMaker mirror — a sync truncates fm.Firma and would reset a flag kept there. */
  aktiv: boolean
}

/**
 * Companies for a picker. Inactive ones are left out by default, so switching a company
 * off in /admin/firma-policy removes it from every selection list at once.
 * Pass `{ all: true }` where the inactive ones must stay visible — the admin page that
 * owns the switch, otherwise a company could never be turned back on.
 */
export function useFirma(opts: { all?: boolean } = {}) {
  const all = opts.all === true
  return useQuery({
    queryKey: ['firma', all ? 'all' : 'active'],
    queryFn: () => api.get<Firma[]>(`/api/firma${all ? '?all=1' : ''}`),
    staleTime: 5 * 60_000,
  })
}
